export enum ValidationState {
  Idle = "idle",
  Success = "success",
  Error = "error",
}
